<script setup lang="ts">
import { useModalManager } from "@/composables/useModalManager";
import { usePayments } from "@/composables/usePayments";
import { useAuthenticationStore } from "@/stores/useAuthenticationStore";
import { ModalEnum } from "@/types/enums";
import { ref, watch } from "vue";
import BaseModal from "./BaseModal.vue";

const authStore = useAuthenticationStore();
const { activeModal } = useModalManager();
const { makePayment } = usePayments();
const show = ref(false);

watch(
  [() => activeModal.value, () => authStore.user],
  ([modal, user]) => {
    if (modal === ModalEnum.PayAfterAuthModal && user && !user?.has_access) {
      show.value = true;
      makePayment(authStore.user);
    }
  },
  { immediate: true },
);
</script>

<template>
  <BaseModal width="510px" :hideHead="true" v-model:visible="show">
    <div class="flex flex-col items-center justify-center gap-2 p-4 text-center">
      <h2 class="text-[1.2rem] font-bold text-black">Please wait...</h2>
      <i class="pi pi-spin pi-spinner text-[2rem]"></i>
    </div>
  </BaseModal>
</template>
